import { useState, useEffect } from   'react';
import { useNavigate, useParams} from 'react-router-dom';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { useForm } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';  
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useAuth } from '../../Auth/AuthContext';

export default function DXIdentificacion() {
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { iddx } = useParams();
    const { idrecepcion } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [btnGuardarDisabled, setBtnGuardarDisabled] = useState(false);
    const [estadoDx, setEstadoDx] = useState('');
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [motivo, setMotivo] = useState('');
    const [motivoBloqueo, setMotivoBloqueo] = useState('');
    const {register, handleSubmit, reset, watch, formState: { errors }} = useForm();
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const onSubmit = async (data) => {
            setBtnGuardarDisabled(true);
            setCargando(true);
            const url = '/diagnostico/guardaridentificacion';
            try {
                const response = await apiService.post(url, data, token);
                if(response.status === 200){
                    if(Number(response.data.estadodx) > 1){
                        navigate(`/dx/hogar/${response.data.iddx}/${idrecepcion}`);
                    }else{
                        Mensaje('Guardar Identificación', 'El diagnóstico base no se ha guardado correctamente');
                    }
                }
            } catch (error) {
                if(error.status === 422){
                    Mensaje('Guardar Identificacion', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Guardar Identificacion', JSON.stringify(error.response.data));
                }
                console.error('Error fetching data:', error);
            } finally {
              setCargando(false);
              setBtnGuardarDisabled(false);
            }
          };
    async function LiberarDX() {
        setCargando(true);
        const url = '/diagnostico/liberardiagnostico';
        const obj = {
            usrid : user,
            idrecepcion: idrecepcion,
            motivo: motivo,
        };
        await apiService.post(url, obj, token)
            .then((response) => {
                if(response.status === 200){
                    Mensaje('Liberar Diagnóstico', 'Diagnóstico liberado correctamente');
                    navigate('/dx/diagnosticodx');
                }
            })
            .catch((error) => {
                if(error.status === 422){
                    Mensaje('Liberar Diagnóstico', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Liberar Diagnóstico', JSON.stringify(error.response.data));
                }
                console.error('Error liberando diagnóstico:', error);
            })
            .finally(() => {
                setCargando(false);
            });
    }
    async function BloquearDX() {
        setCargando(true);
        const url = '/diagnostico/bloqueardiagnostico';
        const obj = {
            usrid : user,
            idrecepcion: idrecepcion,
            motivo: motivoBloqueo,
        };
        await apiService.post(url, obj, token)  
            .then((response) => {
                if(response.status === 200){
                    Mensaje('Bloquear Diagnóstico', 'Diagnóstico bloqueado correctamente');
                    navigate('/dx/diagnosticodx');
                }
            })
            .catch((error) => {
                if(error.status === 422){
                    Mensaje('Bloquear Diagnóstico', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Bloquear Diagnóstico', JSON.stringify(error.response.data));
                }
                console.error('Error bloqueando diagnóstico:', error);
            })
            .finally(() => {
                setCargando(false);
            });
    }
    
    function applyResponseData(response, reset, user, setTiposDocumento) {
        setTiposDocumento(response.data.tiposdocumento);
        setEstadoDx(response.data.estadodx);
        setTimeout(() => {
            reset((prevValues) => ({
                ...prevValues,
                ...response.data.recepcionDiagnostico,
                id_1_2_1_t_documento: response.data.recepcionDiagnostico.id_1_2_1_t_documento?.toString() ?? '',
                usrId: user,
            }));
        }, 0);
    }

    function handleResponse(response, reset, user, setTiposDocumento) {
        if (response.status === 200) {
            applyResponseData(response, reset, user, setTiposDocumento);
        }
    }

    function handleError(error) {
        console.error('Error fetching data:', error);
    }

    useEffect(() => {
        setCargando(true);
        async function fetchData() {
            const url = '/diagnostico/consultaridentificacion';
            const obj = {
                idrecepcion: idrecepcion,
            };
            try {
                const response = await apiService.post(url, obj, token);
                handleResponse(response, reset, user, setTiposDocumento);
                setFechaInicioAtencion(response.data.recepcionDiagnostico.rep_fechahoraatencion);
            } catch (error) {
                handleError(error);
            } finally {
                setCargando(false);
            }
        }
        fetchData();
    }, [idrecepcion, token, reset, user])

    const [showLiberarModal, setShowLiberarModal] = useState(false);
    const [showBloquearModal, setShowBloquearModal] = useState(false);

    const openLiberarModal = () => setShowLiberarModal(true);
    const closeLiberarModal = () => setShowLiberarModal(false);
    const openBloquearModal = () => setShowBloquearModal(true);
    const closeBloquearModal = () => setShowBloquearModal(false);

    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Identificación"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Identificación"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={estadoDx} />
                <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={1} estadoDx={estadoDx}/>
                <div id="formDiagnostico" className="card">
                    <div className="row">
                        <div className="btn-group">
                            <button
                                id="btnModalLiberalDX"
                                type="button"
                                className="btn btn-default"
                                onClick={openLiberarModal}
                            >
                                Liberar
                            </button>
                            <button
                                id="btnModalBloquearDX"
                                type="button"
                                className="btn btn-default"
                                onClick={openBloquearModal}
                            >
                                Bloquear
                            </button>
                            <button id="btnRealizarVisita" type="button" className="btn btn-default" data-toggle="modal" data-target="#modal-visitas">Realizar visita</button>
                        </div>
                    </div>
                    {showLiberarModal && (
                        <div className="modal fade show" style={{display: 'block'}} tabIndex="-1" aria-labelledby="modalLiberarDXLabel" aria-modal="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="modalLiberarDXLabel">Liberar Diagn&oacute;stico</h5>
                                        <button type="button" className="close" aria-label="Cerrar" onClick={closeLiberarModal}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label htmlFor="motivoLiberarDX">Motivo de la liberaci&oacute;n</label>
                                            <textarea
                                                id="motivoLiberarDX"
                                                className="form-control"
                                                rows="3"
                                                maxLength="500"
                                                placeholder="Ingrese el motivo de la liberación"
                                                value={motivo}
                                                onChange={e => setMotivo(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <p>¿Est&aacute; seguro que desea liberar este diagn&oacute;stico?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeLiberarModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={() => { closeLiberarModal(); LiberarDX(); }}>
                                            Liberar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showBloquearModal && (
                        <div className="modal fade show" style={{display: 'block'}} tabIndex="-1" aria-labelledby="modalBloquearDXLabel" aria-modal="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="modalBloquearDXLabel">Bloquear Diagn&oacute;stico</h5>
                                        <button type="button" className="close" aria-label="Cerrar" onClick={closeBloquearModal}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label htmlFor="motivoBloquearDX">Motivo del bloqueo</label>
                                            <textarea
                                                id="motivoBloquearDX"
                                                className="form-control"
                                                rows="3"
                                                maxLength="500"
                                                placeholder="Ingrese el motivo del bloqueo"
                                                value={motivoBloqueo}
                                                onChange={e => setMotivoBloqueo(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <p>¿Est&aacute; seguro que desea bloquear este diagn&oacute;stico?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeBloquearModal}>Cancelar</button>
                                        <button type="button" className="btn btn-danger" onClick={() => { closeBloquearModal(); BloquearDX(); }}>
                                            Bloquear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div id="divFichoAsignado" className="col-lg-12 col-xs-12">
                            {/* small box */}
                            <div className="small-box bg-blue">
                            <div className="inner">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h1 className="pull-right" id="nombrePersonaDiagnostico">{watch('nombrepersonadiagnostico')}</h1>
                                        Ficho Numero: <h2 id="personaFichoNumero">{watch('rep_fichodia')}</h2>
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Codigo: </strong> <span id="txtid">{watch('id')}</span><br/>
                                        <strong>Fecha atenci&oacute;n: </strong> <span id="txtdx_fecha">{watch('rep_fechahoraatencion')}</span><br/>
                                        <strong>Nombre de la Persona Responsable de la Atenci&oacute;n: </strong> <span id="txtdx_7_1_nombre_responsable_atencion">{watch('dx_7_1_nombre_responsable_atencion')}</span><br/>
                                        <strong>Sede: </strong> <span id="slcdx_7_2_sede">{watch('nombreSede')}</span><br/>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>                        
                    </div> 
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className='card-header'>
                                        <h4>1. IDENTIFICACI&oacute;N DE LA PERSONA A LA QUE SE LE APLICA EL DIAGN&oacute;STICO BASE JEFE/A DE HOGAR</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className="row">
                                            <div className="card-title">
                                                <h5><b>1.1. Nombre del Jefe(a) del hogar.</b></h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor='id_1_1_1_p_nombre'>1.1.1. Primer Nombre</label>
                                                <input
                                                    id="id_1_1_1_p_nombre"
                                                    maxLength="30"
                                                    type="text"
                                                    className={`form-control ${errors.id_1_1_1_p_nombre ? 'is-invalid' : ''}`}
                                                    placeholder="Primer Nombre"
                                                    {...register('id_1_1_1_p_nombre', { required: 'El primer nombre es obligatorio' })}
                                                />
                                                {errors.id_1_1_1_p_nombre && (
                                                    <div className="invalid-feedback">{errors.id_1_1_1_p_nombre.message}</div>
                                                )}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor='id_1_1_2_s_nombre'>1.1.2. Segundo Nombre</label>
                                                <input
                                                    id="id_1_1_2_s_nombre"
                                                    maxLength="30"
                                                    type="text"
                                                    className={`form-control ${errors.id_1_1_2_s_nombre ? 'is-invalid' : ''}`}
                                                    placeholder="Segundo Nombre"
                                                    {...register('id_1_1_2_s_nombre')}
                                                />
                                                {errors.id_1_1_2_s_nombre && (
                                                    <div className="invalid-feedback">{errors.id_1_1_2_s_nombre.message}</div>
                                                )}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor='id_1_1_3_p_apellido'>1.1.3. Primer Apellido</label>
                                                <input
                                                    id="id_1_1_3_p_apellido"
                                                    maxLength="30"
                                                    type="text"
                                                    className={`form-control ${errors.id_1_1_3_p_apellido ? 'is-invalid' : ''}`}
                                                    placeholder="Primer Apellido"
                                                    {...register('id_1_1_3_p_apellido', { required: 'El primer apellido es obligatorio' })}
                                                />
                                                {errors.id_1_1_3_p_apellido && (
                                                    <div className="invalid-feedback">{errors.id_1_1_3_p_apellido.message}</div>
                                                )}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor='id_1_1_4_s_apellido'>1.1.4. Segundo Apellido</label>
                                                <input
                                                    id="id_1_1_4_s_apellido"
                                                    maxLength="30"
                                                    type="text"
                                                    className={`form-control ${errors.id_1_1_4_s_apellido ? 'is-invalid' : ''}`}
                                                    placeholder="Segundo Apellido"
                                                    {...register('id_1_1_4_s_apellido')}
                                                />
                                                {errors.id_1_1_4_s_apellido && (
                                                    <div className="invalid-feedback">{errors.id_1_1_4_s_apellido.message}</div>
                                                )}
                                                </div>  
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="card-title">
                                                <h5><b>1.2. Documento Identidad</b></h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <div className="form-group">
                                                <label htmlFor='slcid_1_2_1_t_documento'>1.2.1. Tipo de Documento</label>
                                                <select
                                                    className={`form-control ${errors.id_1_2_1_t_documento ? 'is-invalid' : ''}`}
                                                    id="id_1_2_1_t_documento"
                                                    style={{ width: "100%" }}
                                                    {...register('id_1_2_1_t_documento', { required: 'El tipo de documento es obligatorio' })}
                                                >
                                                    <option value="">Seleccione un tipo de documento</option>
                                                    {tiposDocumento.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tip_tipoidentificacion}-{tipo.tip_descripcion}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.id_1_2_1_t_documento && (
                                                    <div className="invalid-feedback">{errors.id_1_2_1_t_documento.message}</div>
                                                )}
                                                </div>  
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                <label htmlFor='txtid_1_2_2_n_documento'>1.2.2. N&uacute;mero del Documento</label>
                                                    <input
                                                        id="id_1_2_2_n_documento"
                                                        maxLength="20"
                                                        type="text"
                                                        className={`form-control ${errors.id_1_2_2_n_documento ? 'is-invalid' : ''}`}
                                                        placeholder="Número del Documento"
                                                        {...register('id_1_2_2_n_documento', { 
                                                            required: 'El número del documento es obligatorio',
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9]+$/,
                                                                message: 'El número del documento debe contener solo letras y/o números'
                                                            },
                                                            validate: value => value && value !== "0" ? true : "El número del documento no puede ser 0 ni estar vacío"
                                                        })}
                                                    />
                                                    {errors.id_1_2_2_n_documento && (
                                                        <div className="invalid-feedback">{errors.id_1_2_2_n_documento.message}</div>
                                                    )}
                                                </div>  
                                            </div>
                                        </div>                    
                                        <div className="row">
                                            <div className="col-md-6">
                                                <button 
                                                    type="submit" 
                                                    id="btnDiagnosticoGuardar" 
                                                    className="btn btn-block btn-primary btn-sm"
                                                    disabled={btnGuardarDisabled}
                                                    >Guardar y seguir con Hogar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Observaci&oacute;n consulta a base de datos VIVANTO, SISBEN y ADRES.</h3>
                                    </div>
                                    <div className="card-body" >
                                        <div className="row">
                                            <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor='txtobs_vivanto'>Observaciones VIVANTO</label>
                                                <textarea
                                                    id="txtobs_vivanto"
                                                    maxLength="1020"
                                                    rows="3"
                                                    className="form-control"
                                                    placeholder="Observaciones VIVANTO"
                                                    {...register('rep_obsvivanto')}
                                                />
                                                {errors.rep_obsvivanto && (
                                                    <div className="invalid-feedback">{errors.rep_obsvivanto.message}</div>
                                                )}
                                            </div>
                                            </div> 
                                            <div hidden className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor='txtobs_sigma'>Observaciones SIGMA</label>
                                                <textarea id="txtobs_sigma" maxLength="1020" rows="3" className="form-control" placeholder="" />
                                            </div>
                                            </div>
                                            <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor='txtobs_sisben'>Observaciones SISBEN</label>
                                                <textarea
                                                    id="txtobs_sisben"
                                                    maxLength="1020"
                                                    rows="3"
                                                    className="form-control"
                                                    placeholder="Observaciones SISBEN"
                                                    {...register('rep_obssisben')}
                                                />
                                                {errors.rep_obssisben && (
                                                    <div className="invalid-feedback">{errors.rep_obssisben.message}</div>
                                                )}
                                            </div>
                                            </div>
                                            <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor='rep_obsfosyga'>Observaciones ADRES</label>
                                                <textarea
                                                    id="rep_obsfosyga"
                                                    maxLength="1020"
                                                    rows="3"
                                                    className="form-control"
                                                    placeholder="Observaciones ADRES"
                                                    {...register('rep_obsfosyga')}
                                                />
                                                {errors.rep_obsfosyga && (
                                                    <div className="invalid-feedback">{errors.rep_obsfosyga.message}</div>
                                                )}
                                            </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    {/* /.box-body */}
                                </div>
                                {/* /.box */}
                            </div>
                        </div>
                    </form>
                </div>     
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
            {/* /.content */}
        </div>
    )
  }